import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="M185-145h590q16 0 28 11 12 12 12 29t-12 28q-12 11-28 11H185q-16 0-28-11t-11-29q0-16 11-28 12-11 28-11Zm195-100q-16 0-28-12t-11-28v-215h-92q-25 0-35-22t5-41l230-293q6-8 15-11 8-3 16-3t16 3q9 3 15 11l229 293q15 20 5 41t-35 22h-90v215q0 17-12 28t-28 12H380Zm40-80h120v-271h75L480-764 345-596h75v271Zm60-271Z"/>',
  f: '<path d="M185-145h590q16 0 28 11t12 29q0 16-12 28-12 11-28 11H185q-16 0-28-11-11-12-11-28 0-17 11-29 12-11 28-11Zm195-100q-17 0-28-11-11-12-11-29v-215h-92q-25 0-35-22t5-41l230-293q6-8 14-11t17-3q9 0 17 3t14 11l229 293q15 20 5 41t-35 22h-90v215q0 17-12 29-11 11-28 11H380Z"/>',
};

export default data;
